import { CommentCategory } from '../enums';

export class CalculationComment {
    public category: CommentCategory;
    public owner: string;
    public timeStamp: Date;
    public text: string;

    public constructor(init: Partial<CalculationComment>) {
        Object.assign(this, init);
    }
}
